const RAILS_SERVER_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export function apiUrl(path: string) {
  let cleanPath = path;
  if (path.startsWith("/")) {
    cleanPath = path.slice(1);
  }

  return `${RAILS_SERVER_URL}/${cleanPath}`;
}

export function fetchApi(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  const { headers, ...rest } = options;
  return fetch(apiUrl(path), {
    cache: "no-store",
    credentials: "include",
    ...rest,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...headers,
    },
  });
}
